/** Día de la semana de cada sesión Training (gimnasio / running / natación). */

export const WEEKDAY_IDS = Object.freeze([
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
]);

export const WEEKDAYS = Object.freeze([
  { id: 'monday', label: 'Lunes' },
  { id: 'tuesday', label: 'Martes' },
  { id: 'wednesday', label: 'Miércoles' },
  { id: 'thursday', label: 'Jueves' },
  { id: 'friday', label: 'Viernes' },
  { id: 'saturday', label: 'Sábado' },
  { id: 'sunday', label: 'Domingo' },
]);

const ALIASES = Object.freeze({
  monday: 'monday',
  mon: 'monday',
  lun: 'monday',
  lunes: 'monday',
  tuesday: 'tuesday',
  tue: 'tuesday',
  mar: 'tuesday',
  martes: 'tuesday',
  wednesday: 'wednesday',
  wed: 'wednesday',
  mie: 'wednesday',
  miercoles: 'wednesday',
  miércoles: 'wednesday',
  thursday: 'thursday',
  thu: 'thursday',
  jue: 'thursday',
  jueves: 'thursday',
  friday: 'friday',
  fri: 'friday',
  vie: 'friday',
  viernes: 'friday',
  saturday: 'saturday',
  sat: 'saturday',
  sab: 'saturday',
  sabado: 'saturday',
  sábado: 'saturday',
  sunday: 'sunday',
  sun: 'sunday',
  dom: 'sunday',
  domingo: 'sunday',
});

export function normalizeWeekday(raw) {
  const v = String(raw || '').toLowerCase().trim();
  if (!v) return '';
  if (WEEKDAY_IDS.includes(v)) return v;
  return ALIASES[v] || '';
}

export function weekdayLabel(raw) {
  const id = normalizeWeekday(raw);
  const row = WEEKDAYS.find((w) => w.id === id);
  return row ? row.label : '';
}

export function sequentialWeekdays(count, startId = 'monday') {
  const n = Math.max(0, Number(count) || 0);
  const start = WEEKDAY_IDS.indexOf(normalizeWeekday(startId) || 'monday');
  const from = start >= 0 ? start : 0;
  return Array.from({ length: n }, (_, i) => WEEKDAY_IDS[(from + i) % 7]);
}

export function nextWeekday(raw) {
  const id = normalizeWeekday(raw);
  if (!id) return 'monday';
  const i = WEEKDAY_IDS.indexOf(id);
  return WEEKDAY_IDS[(i + 1) % 7];
}

export function formatDayWithWeekday(day = {}) {
  const wd = weekdayLabel(day.weekday);
  const nombre = String(day.nombre || '').trim();
  if (wd && nombre) return `${wd} · ${nombre}`;
  if (wd) return `Día ${day.dia || ''} · ${wd}`.replace(/\s+/g, ' ').trim();
  return nombre || `Día ${day.dia || ''}`.trim();
}
